import React from 'react';

const PlanDetails = props => {
  const renderPermissions = () => {
    return props.plan.permissions && props.plan.permissions.length > 0 ? (
      <div>
        {props.plan.permissions.length == 1 ? (
          <div>
            <h4>Permission Enabled by the Plan :</h4>
            <p>{props.plan.permissions[0].description}</p>
          </div>
        ) : (
          <div>
            <h4>Permissions Enabled by the Plan :</h4>
            <ul>
              {props.plan.permissions.map(permission => {
                return <li key={permission._id}>{permission.description}</li>
              })}
            </ul>
          </div>
        )}
        <hr className='dotted short' />
      </div>
    ) : null;
  }
  const renderDiscounts = () => {
    return props.plan.discounts && props.plan.discounts.length > 0 ? (
      <div>
        <h4>{props.plan.discounts.length == 1 ? 'Discount' : 'Discounts'} :</h4>
        {props.plan.discounts.length == 1 ? (
          props.plan.discounts[0].max == null ? (
            <p>
              ${props.plan.discounts[0].amount} discount if at least {props.plan.discounts[0].min} plans are subscribed
            </p>
          ) : (
            <p>
              ${props.plan.discounts[0].amount} discount if {props.plan.discounts[0].min} - {props.plan.discounts[0].max} plans are subscribed
            </p>
          )
        ) : (
          <ul>
            {props.plan.discounts.sort((a,b) => a.min < b.min ? -1 : 1).map(discount => {
              const { min, max, amount } = discount;
              return discount.max == null ? (
                <li key={`${discount.min}-${discount.amount}`}>
                  ${amount} discount if at least {min} plans are subscribed
                </li>
              ) : (
                <li key={`${discount.min}-${discount.amount}`}>
                  ${amount} discount if {min} - {max} plans are subscribed
                </li>
              )
            })}
          </ul>
        )}
      </div>
    ) : null;
  }

  const {
    name,
    description,
    amount,
    interval,
    permissions,
    discounts
  } = props.plan || {};
  return props.plan ? (
    <div className='plan-details-container'>
      <h2>{name}</h2>
      <hr className='dotted short' />
      {description ? (
        <div>
          <h4>Description :</h4>
          <p>{description}</p>
          <hr className='dotted short' />
        </div>
      ) : null}
      {interval ? (
        <div>
          <h4>Plan Interval :</h4>
          <p>{`${interval[0].toUpperCase()}${interval.substr(1)}`}</p>
          <hr className='dotted short' />
        </div>
      ) : null}
      {renderPermissions()}
      <div>
        <h4>Price :</h4>
        <p>{`$${(+amount / 100).toFixed(2)}`}</p>
        {discounts && discounts.length > 0 ? <hr className='dotted short' /> : null}
      </div>
      {renderDiscounts()}
    </div>
  ) : null;
}

export default PlanDetails;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/plan-details.js